<template>
  <div class="app-body" ref="appContent">
    <div class="table-bar" style="margin-bottom: 10px;">
      <el-button type="primary" size="mini" @click="$refs.CountSelDialog.init()">选择原料</el-button>
    </div>
    <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="0"
    >
      <el-table
          :data="dataForm.detailList"
          border
          style="width: 100%"
          ref="table"
          :max-height="maxTableHeight"
      >
        <el-table-column
            type="index"
            width="50"
            label="行号"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column label="订单编号" min-width="160" prop="agreementCode" header-align="center" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="仓库名称" min-width="160" prop="storageName" header-align="center" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="原料名称" align="center" prop="name" min-width="100" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="颜色"
            prop="color"
            header-align="center"
            align="center"
            min-width="100"
        >
        </el-table-column>
        <el-table-column
            label="规格"
            prop="size"
            header-align="center"
            align="center"
            min-width="100"
        >
        </el-table-column>
        <el-table-column
            label="幅宽"
            prop="attr1"
            header-align="center"
            align="center"
            min-width="100"
        >
        </el-table-column>
        <el-table-column
            label="克重"
            prop="attr2"
            header-align="center"
            align="center"
            min-width="100"
        >
        </el-table-column>
        <el-table-column
            label="库存数量"
            prop="oldCount"
            header-align="center"
            align="center"
        >
        </el-table-column>
        <el-table-column
            label="实际库存"
            header-align="center"
            align="center"
            width="130"
            fixed="right"
        >
          <template slot-scope="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.count'"
                :rules="detailRule.count"
                label-width="0"
                style="margin-bottom: 0"
            >
              <el-input v-model="scope.row.count" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button
                type="text"
                icon="el-icon-remove"
                size="mini"
                @click="delRow(scope.$index, scope.row)"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div class="form-foot">
      <el-button @click="$router.back()">取消</el-button>
      <el-button type="primary" :loading="saveLoading" @click="dataFormSubmitHandle">保存</el-button>
    </div>
    <count-sel-dialog ref="CountSelDialog" @change="selChanged"></count-sel-dialog>
  </div>
</template>

<script>
import CountSelDialog from '@/views/modules/StoreManager/common/count-sel-dialog'
import { isPositiveNumber } from '@/utils/validate'
import debounce from 'lodash/debounce'
import BigNumber from 'bignumber.js'

export default {
  name: 'settle',
  components: { CountSelDialog },
  data () {
    return {
      dataForm: {
        detailList: []
      },
      detailRule: {
        count: [
          {
            validator: function (rule, value, callback) {
              if (value&&!isPositiveNumber(value)) {
                callback(new Error('请输入正确的数量'))
                return
              }
              callback()
            },
            trigger: 'change',
          },
        ]
      },
      maxTableHeight: 400,
      saveLoading: false
    }
  },
  activated () {
    this.dataForm={
      detailList: []
    }
    this.$nextTick(() => {
      this.maxTableHeight =
          document.body.clientHeight -
          180
    })
  },
  beforeRouteLeave (to, from, next) {
    if(this.$refs.CountSelDialog){
      this.$refs.CountSelDialog.clearSelection()
    }
    next()
  },
  methods: {
    async doSave () {
      let postForm = this.dataForm.detailList.filter(item => {
        return !new BigNumber(item.count).isNaN()
      }).map(item => {
        return {
          productId: item.productId,
          agreementId: item.agreementId,
          count: item.count,
          storageId: item.storageId,
        }
      })
      if(!postForm||postForm.length===0){
        return this.$message.error('没有可保存的数据')
      }
      this.saveLoading = true
      try {
        const { data: res } = await this.$http.post(`/erp/store/material/settle`, postForm)
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('保存成功')
        this.saveLoading = false
        this.$router.back()
      } catch (e) {
        this.saveLoading = false
        console.log(e)
      }
    },
    selChanged (data) {
      if (!data || data.length === 0) {
        return
      }
      data.forEach(item => {
        let existItem = this.dataForm.detailList.find(m => m.id === item.id)
        if (existItem) {
          return
        }
        this.dataForm.detailList.push({
          id: item.id,
          agreementCode: item.agreementCode,
          agreementId: item.agreementId,
          storageId: item.storageId,
          storageName: item.storageName,
          productId:item.productId,
          name: item.name,
          color: item.color,
          size: item.size,
          attr1: item.attr1,
          attr2: item.attr2,
          unit: item.unit,
          oldCount: item.count,
          count: null
        })
      })
    },
    delRow (index, row) {
      this.dataForm.detailList.splice(index, 1)
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            console.log(valid)
            if (!valid) {
              return false
            }
            this.doSave()
          })
        }, 1000,
        { leading: true, trailing: false })
  }
}
</script>

<style scoped>

</style>
